























import Vue from "vue";
import Button from "@/components/Button.vue";
import authService from "@/services/auth.service";

export default Vue.extend({
  components: {
    Button,
  },
  data() {
    return {
      isOpen: false,
      isLoggingOut: false,
      currentUser: "",
    };
  },
  computed: {
    getToggleIcon(): string {
      return this.isOpen ? "mdi-chevron-up" : "mdi-chevron-down";
    },
  },
  mounted() {
    var user = authService.getUser();
    this.currentUser = user?.name || "";
  },
  methods: {
    toggle(): void {
      this.isOpen = !this.isOpen;
    },
    logout() {
      this.isLoggingOut = true;
      authService.logout().then(
        () => {
          this.isLoggingOut = false;
        },
        () => {
          this.isLoggingOut = false;
          this.$toast.error("Klarte ikke å logge deg ut");
        }
      );
    },
  },
});
